"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M23,1v22H1V1H23 M24,0H0v24h24V0L24,0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M14.7,8.7c-0.1,0.1,0,0.3,0,0.3v9.2H9.3V9.1c0,0,0-0.2-0.1-0.3C9.1,8.6,8.9,8.7,8.9,8.7H3.4v-3h17.2v3H15 C15,8.7,14.8,8.6,14.7,8.7"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#004864",
    points: "7.9,15.3 7.9,18.3 3.4,18.3 3.4,9.3 7.9,9.3 7.9,12.3 8.9,12.3 8.9,15.3     "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M15,12.3h0.3c0,0,0.4,0,0.6-0.2c0.3-0.3,0.2-0.8,0.2-0.8v-2h4.4c0,0,0.2,2.5-0.8,3.5c-1,1-3.6,0.8-3.6,0.8 v0.5c0,0,2.6-0.3,3.6,0.8c1,1,0.8,3.5,0.8,3.5h-4.4v-2c0,0,0-0.6-0.2-0.8c-0.3-0.3-0.6-0.2-0.6-0.2H15V12.3z"
  }));
};

exports["default"] = _default;